@if (form) {
<div [formGroup]="form" class="legal-person-form">
  <mat-vertical-stepper #details [linear]="false">
    <mat-step label="Name und Adresse" [completed]="form.controls[namePath].valid && business.valid && legal.valid">
      <mat-form-field appearance="outline" class="full"><mat-label>Organisationsname</mat-label><input matInput
          [formControlName]="namePath"><mat-error>Bitte den Organisationsnamen eingeben.</mat-error></mat-form-field>
      <h3>Geschäftsadresse</h3>
      <ng-container *ngTemplateOutlet="addressFieldsTemplate; context: { group: business }"></ng-container>
      <mat-checkbox [checked]="sameAddress" (change)="copyAddress($event.checked)">Meine Geschäftsadresse ist auch meine
        juristische Anschrift</mat-checkbox>
      @if (!sameAddress) { <h3>Juristische Anschrift</h3><ng-container
        *ngTemplateOutlet="addressFieldsTemplate; context: { group: legal }"></ng-container> }
      <div class="actions"><button mat-flat-button color="primary" type="button" matStepperNext
          [disabled]="form.controls[namePath].invalid || business.invalid || legal.invalid">Weiter</button></div>
    </mat-step>
    <mat-step label="Identifikationsnummern" [completed]="registrations.valid">
      @for (registration of registrations.controls; track registration; let index = $index) {
      <div class="registration-row" [formGroup]="registrationGroup(index)">
        <mat-form-field appearance="outline"><mat-label>ID-Typ</mat-label><mat-select [value]="registrationPath(index)"
            (selectionChange)="changeType(index, $event.value)">
            @for (type of registrationTypes; track type.path) { <mat-option [value]="type.path">{{ type.label
              }}</mat-option> }
          </mat-select></mat-form-field>
        <mat-form-field appearance="outline"><mat-label>Nummer</mat-label><input matInput
            [formControlName]="registrationPath(index)"><mat-error>Bitte eine Nummer
            eingeben.</mat-error></mat-form-field>
        <button mat-icon-button type="button" [disabled]="registrations.length === 1"
          (click)="removeRegistration(index)"
          aria-label="Identifikationsnummer entfernen"><mat-icon>delete_outline</mat-icon></button>
      </div>
      }
      <button mat-stroked-button type="button" (click)="addRegistration()"><mat-icon>add</mat-icon>Weitere ID
        hinzufügen</button>
      <div class="actions"><button mat-button type="button" matStepperPrevious>Zurück</button><button mat-flat-button
          color="primary" type="button" matStepperNext [disabled]="registrations.invalid">Weiter</button></div>
    </mat-step>
    <mat-step label="Weitere Informationen">
      <mat-form-field appearance="outline" class="full"><mat-label>Beschreibung Ihrer Organisation
          (optional)</mat-label><textarea matInput rows="4"
          [formControlName]="descriptionPath"></textarea></mat-form-field>
      <div class="actions"><button mat-button type="button" matStepperPrevious>Zurück</button></div>
    </mat-step>
  </mat-vertical-stepper>
</div>
<ng-template #addressFieldsTemplate let-group="group">
  <div class="address-grid" [formGroup]="group">
    @for (field of addressFields; track field.path) {
    <mat-form-field appearance="outline" [class.full]="field.path.endsWith('street-address')"><mat-label>{{
        label(field.path) }}</mat-label>@if (field.path.endsWith('countryCode')) { <mat-select [formControlName]="field.path">@for (country of countryCodes; track country[0]) { <mat-option [value]="country[0]">{{ country[0] }} · {{ country[1] }}</mat-option> }</mat-select> } @else { <input matInput [formControlName]="field.path"> }<mat-error>Bitte einen gültigen
        Wert eingeben.</mat-error></mat-form-field>
    }
  </div>
</ng-template>
}
